<template>
  <div class="pb-9">
    <div v-if="loading" class="text-center pt-8">
      <Loading></Loading>
    </div>
    <v-container
      v-else-if="product && product.length"
      style="padding-bottom: 60px"
    >
      <div style="text-align: center" class="py-2 mb-3">
        <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
      </div>
      <div style="text-align: center">
        <div style="width: 150px; margin-left: auto; margin-right: auto">
          <div v-if="product[0].image">
            <v-img
              style="height: 100%"
              lazy-src="../assets/whiteimg.jpg"
              :src="product[0].image"
              @error="() => (product[0].image = null)"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>
          <div v-else>
            <div
              style="
                height: 100px;
                width: 100px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <v-icon>mdi-block-helper</v-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="pa-4">
        <div
          class="Kanit text-center"
          style="color: #0a4ea2; font-size: 18px; font-weight: bold"
        >
          {{ query.group }}
        </div>
        <div class="mt-6 Kanit text-center">
          <div class="productlabel">จำนวน</div>
          <number-input
            size="small"
            v-model="input.quantity"
            :min="1"
            inline
            center
            controls
          ></number-input>
          <div class="productlabel">ขนาด</div>
          <div>
            <div
              class="px-3"
              @click="selectSize(item)"
              :style="`background-color: ${
                input.size == item ? 'grey' : 'rgb(230 230 230)'
              }; color: ${input.size == item ? 'white' : 'black'}`"
              style="
                padding: 5px;
                margin: 8px;
                display: inline-block;
                border-radius: 9px;
                cursor: pointer;
              "
              v-for="(item, k) in sizes"
              :key="k"
            >
              {{ item !== null ? item : "ไม่มีไซซ์" }}
            </div>
          </div>
          <template v-if="hardwareType == 'Abrasive'">
            <div class="productlabel">เบอร์</div>
            <div>
              <div
                class="px-3"
                @click="selectPaperNumber(item)"
                :style="`background-color: ${
                  input.paper_number == item ? 'grey' : 'rgb(230 230 230)'
                }; color: ${input.paper_number == item ? 'white' : 'black'}`"
                style="
                  padding: 5px;
                  margin: 8px;
                  display: inline-block;
                  border-radius: 9px;
                  cursor: pointer;
                "
                v-for="(item, k) in abrasive_papernumber"
                :key="k + item"
              >
                <span v-if="item">
                  {{ item | removeSharp }}
                </span>
                <span v-else> {{ "-" }}</span>
              </div>
            </div>
          </template>
          <template
            v-if="
              hardwareType == 'Solvent' &&
              solvent_number &&
              solvent_number.length
            "
          >
            <div class="productlabel">เบอร์</div>
            <div>
              <div
                class="px-3"
                @click="selectSolventNumber(item)"
                :style="`background-color: ${
                  input.solvent_number == item ? 'grey' : 'rgb(230 230 230)'
                }; color: ${input.solvent_number == item ? 'white' : 'black'}`"
                style="
                  padding: 5px;
                  margin: 8px;
                  display: inline-block;
                  border-radius: 9px;
                  cursor: pointer;
                "
                v-for="(item, k) in solvent_number"
                :key="k + item"
              >
                <span v-if="item">
                  {{ item }}
                </span>
                <span v-else> {{ "ไม่มีเบอร์" }}</span>
              </div>
            </div>
          </template>
          <template v-if="query.main_category == 'Heavy Duty Coatings'">
            <div class="productlabel">ฟิล์ม</div>
            <div>
              <div
                class="px-3"
                @click="selectFilm(item)"
                :style="`background-color: ${
                  input.film_type == item ? 'grey' : 'rgb(230 230 230)'
                }; color: ${input.film_type == item ? 'white' : 'black'}`"
                style="
                  padding: 5px;
                  margin: 8px;
                  display: inline-block;
                  border-radius: 9px;
                  cursor: pointer;
                "
                v-for="(item, k) in film_types"
                :key="k + item"
              >
                {{ item ? item : "-" }}
              </div>
            </div>
          </template>
          <template v-if="query.main_category == 'Gypsum'">
            <ValidationObserver ref="observer" tag="form">
              <form>
                <div class="px-8">
                  <div class="productlabel">ขอบ</div>
                  <ValidationProvider
                    :name="'ขอบ'"
                    :rules="'required'"
                    key="edge"
                    v-slot="{ errors }"
                  >
                    <v-select
                      placeholder="กรุณาเลือกขอบ"
                      v-model="input.edge"
                      @change="onChangeEdge"
                      dense
                      outlined
                      :error-messages="errors"
                      :items="edge"
                    ></v-select>
                  </ValidationProvider>
                </div>
                <div class="px-8">
                  <div class="productlabel">ประเภท</div>
                  <ValidationProvider
                    :name="'ประเภท'"
                    :rules="'required'"
                    key="type"
                    v-slot="{ errors }"
                  >
                    <v-select
                      :background-color="input.edge ? 'white' : `#e6e6e6`"
                      v-model="input.type"
                      placeholder="กรุณาเลือกประเภท"
                      :disabled="!input.edge"
                      :error-messages="errors"
                      dense
                      outlined
                      :items="type"
                    ></v-select>
                  </ValidationProvider>
                </div>
              </form>
            </ValidationObserver>
          </template>
          <div
            v-if="
              (query.main_category != `Gypsum` &&
                query.flowtype == 'colorlast') ||
              ['INT', 'EXT'].includes(this.query.category)
            "
            class="mt-6"
          >
            <div v-if="haveColor" class="productlabel">สี</div>
            <div>
              <div v-if="query.color || query.shade">
                <div
                  @click="chooseColor"
                  v-if="query.color && query.color.includes('https://')"
                  style="width: 80px; margin-left: auto; margin-right: auto"
                >
                  <v-img
                    style="margin-left: auto; margin-right: auto"
                    :src="query.color"
                  ></v-img>
                </div>
                <div v-else>
                  <div
                    @click="chooseColor"
                    :style="`margin-left: auto; margin-right: auto;text-align: center; position:relative;width: 180px; height:40px;background-color: ${rgbToHex(
                      query.color
                    )};border-radius: 7px`"
                  >
                    <p
                      class="centerthing"
                      :style="`color: ${
                        $options.filters.setContrast(query.color).text
                      };font-size: 17px`"
                    >
                      {{ query.shade }}
                    </p>
                  </div>
                </div>
              </div>
              <div v-else-if="haveColor">
                <v-btn @click="chooseColor" outlined color="#0A4EA2"
                  >กรุณาเลือกสี</v-btn
                >
                <div
                  v-if="!query.color && errorcolor"
                  style="color: red"
                  class="text-center"
                >
                  กรุณาเลือกสีก่อนเพิ่มลงตะกร้า
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div @click="postProduct" v-ripple class="addcartbtn Kanit myshadow">
        <p v-if="!saveloading">เพิ่มเข้าตะกร้า</p>
        <div v-else>
          <v-progress-circular
            indeterminate
            size="35"
            color="white"
          ></v-progress-circular>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import VueNumberInput from "@chenfengyuan/vue-number-input";
import Loading from "@/components/Loading.vue";

export default {
  components: {
    numberInput: VueNumberInput,
    Loading,
  },
  data() {
    return {
      colorData: [],
      haveColor: false,
      hardwareType: "",
      loading: false,
      serverUrl: "https://communitybotbyzwizai.herokuapp.com/",
      saveloading: false,
      errorcolor: false,
      product: [],
      input: {
        quantity: 1,
        product: "",
        size: "",
        edge: "",
        type: "",
        film_type: "",
        paper_number: "",
        solvent_number: "",
      },
    };
  },
  computed: {
    abrasive_papernumber() {
      var result = this.product
        .filter((el) => el.size == this.input.size)
        .map((el) => el.paper_number);
      return [...new Set(result)];
    },
    solvent_number() {
      var result = this.product
        .filter((el) => el.size == this.input.size)
        .map((el) => el.solvent_number);
      var final = [...new Set(result)];
      if (final && final.length && final[0] == null) {
        return [];
      } else {
        return final;
      }
    },
    formatedProducts() {
      return this.product.filter((el) => el.size == this.input.size);
    },
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
    sizes() {
      var result = this.product.map((el) =>
        el.size !== null ? el.size : null
      );
      return [...new Set(result)];
    },
    edge() {
      var result = this.product
        .filter((el) => el.size == this.input.size)
        .map((el) => el.edge);
      return [...new Set(result)];
    },
    film_types() {
      var result = this.product
        .filter((el) => el.size == this.input.size)
        .map((el) => el.film_type);
      return [...new Set(result)];
    },
    type() {
      var result = this.product.map((el) => el.type);
      return [...new Set(result)];
    },
    selectedProduct() {
      var product = this.product;
      if (product.length) {
        var result = product.filter((el) => {
          if (
            this.query.main_category == "Gypsum" &&
            this.input.edge &&
            this.input.type
          ) {
            return (
              el.size == this.input.size &&
              el.edge == this.input.edge &&
              el.type == this.input.type
            );
          } else if (
            this.query.main_category == "Heavy Duty Coatings" &&
            this.input.film_type
          ) {
            return (
              el.size == this.input.size && el.film_type == this.input.film_type
            );
          } else if (
            this.hardwareType &&
            ["Abrasive", "Latex Adhesive", "Solvent"].includes(
              this.hardwareType
            )
          ) {
            if (this.hardwareType == "Abrasive" && this.input.paper_number) {
              return (
                el.size == this.input.size &&
                el.paper_number == this.input.paper_number
              );
            } else if (this.hardwareType == "Latex Adhesive") {
              return el.size == this.input.size;
            } else if (this.hardwareType == "Solvent") {
              return (
                el.size == this.input.size &&
                el.solvent_number == this.input.solvent_number
              );
            }
          } else {
            if (this.query.shade) {
              if (["INT", "EXT"].includes(this.query.category)) {
                return el.size == this.input.size;
              } else {
                var isSameshade = false;
                if (this.query.isColorWorld == "true") {
                  isSameshade = true;
                } else {
                  isSameshade = el.shade == this.query.shade;
                }
                return isSameshade && el.size == this.input.size;
              }
            } else {
              return el.size == this.input.size;
            }
          }
        });
        return result[0];
      } else return "";
    },
  },
  async mounted() {
    var vm = this;
    await this.getProduct();
    if (this.query.main_category == "Gypsum") {
      this.input.edge = this.edge[0];
      this.input.type = this.type[0];
    }
    if (this.$store.state.input) this.input = this.$store.state.input;
    await vm.getColor(vm.selectedProduct.size);
    if (vm.colorData.length == 1) {
      vm.query.shade = vm.colorData[0].shade;
      vm.query.color = vm.colorData[0].color;
      vm.query.rgb = vm.colorData[0].rgb;
      vm.$forceUpdate();
    }
    if (
      vm.product &&
      vm.product.length &&
      vm.product[0].category &&
      ["Abrasive", "Latex Adhesive", "Solvent"].includes(vm.product[0].category)
    ) {
      vm.haveColor = false;
    } else {
      vm.haveColor = true;
    }
  },
  methods: {
    selectPaperNumber(item) {
      this.input.paper_number = item;
    },
    selectSolventNumber(item) {
      this.input.solvent_number = item;
    },
    selectFilm(item) {
      this.query.film_type = item;
      this.input.film_type = item;
      this.onChangeSize();
    },
    async onChangeSize() {
      var vm = this;
      this.$nextTick(async () => {
        await vm.getColor(vm.selectedProduct.size);
        if (vm.colorData.length == 1) {
          vm.query.shade = vm.colorData[0].shade;
          vm.query.color = vm.colorData[0].color;
          vm.query.rgb = vm.colorData[0].rgb;
          vm.$forceUpdate();
        } else if (
          !["INT", "EXT"].includes(vm.query.category) &&
          vm.query.isColorWorld != "true"
        ) {
          vm.query.shade = "";
          vm.query.color = "";
          vm.query.rgb = "";
          vm.$forceUpdate();
        }
      });
    },
    getColor(size) {
      if (this.query.main_category != "Gypsum") {
        return new Promise((resolve) => {
          axios
            .get(
              "https://communitybotbyzwizai.herokuapp.com/toargborshadecoatings",
              {
                headers: {
                  AUTHORIZATION: "Bearer xxx xxx",
                },
                params: {
                  main_category: this.query.main_category,
                  size,
                  group: this.query.group,
                  flowtype: this.query.flowtype,
                  film_type: this.input.film_type,
                },
              }
            )
            .then(async (response) => {
              this.loading = false;
              if (response.data && response.data.responsecode == 400) {
                await this.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                  confirmButtonText: "ตกลง",
                });
                return;
              } else if (response.data.responsecode == 200) {
                if (!this.query.color) {
                  this.colorData = response.data.data;
                }
              }
              resolve();
            });
        });
      }
    },
    chooseColor() {
      if (!["INT", "EXT"].includes(this.query.category) || (this.selectedProduct && this.selectedProduct.colorworld)) {
        if (this.colorData.length != 1) {
          this.$store.state.input = this.input;
          Object.assign(this.query, {
            view: "DecorativeCoating",
            size: this.selectedProduct.size,
            film_type: this.input.film_type,
          });
        }
      }
    },
    selectSize(item) {
      var oldval = `${this.input.size}`;
      this.input.size = item;
      if (this.query.main_category == "Gypsum" && this.input.size != oldval) {
        this.input.edge = this.edge[0];
        this.input.type = this.type[0];
        this.$refs.observer.reset();
      }

      if (
        this.query.main_category == "Heavy Duty Coatings" &&
        this.input.size != oldval
      ) {
        this.input.film_type = this.film_types[0];
      } else if (
        ["Abrasive", "Latex Adhesive", "Solvent"].includes(this.hardwareType)
      ) {
        if (this.hardwareType == "Abrasive") {
          this.input.paper_number == this.abrasive_papernumber[0];
          this.$set(this.input, "paper_number", this.abrasive_papernumber[0]);
        } else if (this.hardwareType == "Solvent") {
          this.input.solvent_number == this.solvent_number[0];
          this.$set(this.input, "solvent_number", this.solvent_number[0]);
        }
      }
      this.onChangeSize();
    },
    onChangeEdge() {
      this.input.type = this.type[0];
      this.$refs.observer.reset();
    },
    getProduct() {
      this.loading = true;
      var vm = this;
      return new Promise((resolve) => {
        if (this.query.flowtype == "colorfirst") {
          var params = {
            group: decodeURI(this.query.group),
            shade: this.query.shade,
            colorworld: this.query.colorworld,
            category: this.query.category,
            main_category: this.query.main_category,
            flowtype: this.query.flowtype,
          };
        } else {
          var params = {
            group: decodeURI(this.query.group),
            main_category: this.query.main_category,
            flowtype: this.query.flowtype,
          };
        }

        axios
          .get(this.serverUrl + "toaproducts", {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
            params,
          })
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (
              response.data.responsecode == 200 &&
              response.data.data
            ) {
              this.product = response.data.data;
              vm.hardwareType = this.product[0].category;
              if (this.product.length) {
                this.input.size = this.product[0].size;
                if (vm.query.main_category == "Heavy Duty Coatings") {
                  this.input.film_type = this.product[0].film_type;
                } else if (vm.hardwareType == "Abrasive") {
                  this.input.paper_number = this.product[0].paper_number;
                } else if (vm.hardwareType == "Solvent") {
                  this.input.solvent_number = this.product[0].solvent_number;
                }
              }
            }
            this.loading = false;
            resolve();
          });
      });
    },
    async postProduct() {
      if (!this.saveloading) {
        var vm = this;
        var isValid = true;
        if (this.query.main_category == "Gypsum") {
          isValid = await this.$refs.observer.validate();
        }
        if (!this.query.color) {
          this.errorcolor = true;
        }
        if (
          (isValid && this.query.main_category == "Gypsum") ||
          ["Abrasive", "Latex Adhesive", "Solvent"].includes(
            this.hardwareType
          ) ||
          this.query.shade ||
          this.query.color
        ) {
          this.saveloading = true;

          var product = this.selectedProduct;
          var data = {
            userid: this.query.userid,
            apptype: this.query.apptype,
            pageid: this.query.pageid,
            toaid: product.toaid,
            quantity: this.input.quantity,
            option: JSON.stringify({
              ...product,
              color: this.query.color,
              shade: this.query.shade,
              film_type: this.query.film_type,
            }),
          };
          axios
            .post(this.serverUrl + "toaaddtocart", data, {
              headers: {
                AUTHORIZATION: "Bearer xx xx",
              },
            })
            .then(async (response) => {
              this.saveloading = false;
              if (response.data && response.data.responsecode == 400) {
                await this.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
                if (response.data.closed) {
                  if (this.query.apptype == "line") {
                    await this.$liff.closeWindow();
                  } else if (this.query.apptype == "facebook") {
                    this.$store.dispatch("messengerClose");
                  }
                }
              } else if (response.data.responsecode == 200) {
                if (this.query.apptype == "line") {
                  await this.$liff.closeWindow();
                } else if (this.query.apptype == "facebook") {
                  this.$store.dispatch("messengerClose");
                }
              }
            });
        }
      }
    },
    rgbToHex(rgb) {
      if (rgb) {
        var myrgb = rgb.split(",");
      } else return "";
      return (
        "#" +
        (
          (1 << 24) +
          (parseInt(myrgb[0]) << 16) +
          (parseInt(myrgb[1]) << 8) +
          parseInt(myrgb[2])
        )
          .toString(16)
          .slice(1)
      );
    },
  },
  filters: {
    removeSharp(val) {
      return val ? val.replace("#", "") : "";
    },
    setContrast(myrgb) {
      if (myrgb) {
        var rgb = myrgb.split(",");

        // Randomly update colours
        const brightness = Math.round(
          (parseInt(rgb[0]) * 299 +
            parseInt(rgb[1]) * 587 +
            parseInt(rgb[2]) * 114) /
            1000
        );
        const textColour = brightness > 185 ? "black" : "white";
        const backgroundColour =
          "rgb(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + ")";
        return { text: textColour, background: backgroundColour };
      } else {
        return { text: "black", background: "white" };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.centerthing {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.productlabel {
  font-size: 18px;
}
</style>